export default "__VITE_ASSET__HILBDDKU__"